"use client";

import Script from "next/script";
import React from "react";
import { HUBSPOT_FORM } from "@/lib/consts";

function HubSpotForm() {
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const container = containerRef.current;

    if (!container) {
      return;
    }

    // Appending the frame div ourselves is what makes this reliable, and it is
    // the whole reason this component exists instead of a plain JSX div.
    // HubSpot's loader only walks five levels into each node its
    // MutationObserver reports, and this form sits deeper than that inside the
    // page's component tree. Appending the div directly makes IT the reported
    // node, so it matches at depth 0 every time — on a hard load, and on every
    // App Router soft navigation, where the loader's own init has already run
    // and will not run again.
    const frame = document.createElement("div");

    frame.className = "hs-form-frame";
    frame.dataset.region = HUBSPOT_FORM.region;
    frame.dataset.formId = HUBSPOT_FORM.formId;
    frame.dataset.portalId = HUBSPOT_FORM.portalId;

    container.appendChild(frame);

    return () => {
      frame.remove();
    };
  }, []);

  return (
    <React.Fragment>
      {/*
        This reserves space before HubSpot reports a height; it does not set
        the form's height. The form measures itself inside the iframe and
        posts a NEW_HEIGHT message out, which the loader applies. So this
        value only governs how much layout shift a visitor sees, and it is
        measured against the real form: 673px on mobile and 564px on desktop.
        On desktop 36rem reserves 576px, 12px of slack. On mobile 42rem
        reserves 672px, one pixel under, which is close enough to be
        invisible. These numbers describe the current four-field form. If
        fields are added in HubSpot, which is an open request, re-measure and
        adjust, or the jump comes back.
      */}
      <div ref={containerRef} className="w-full min-h-[42rem] md:min-h-[36rem]" />

      <Script src={HUBSPOT_FORM.src} strategy="afterInteractive" />
    </React.Fragment>
  );
}

export default HubSpotForm;
